const base = require("./base");
const slickCarousel = require("../components/initSlickSlider");
const {setBadgeColors} = require("./producttile");
const formHelpers = require("../components/formErrors");
const recaptcha = require("google/recaptcha");
const { setCSRFToken } = require("../components/utils");
const { updateBottomBackToTop } = require("../components/backToTop");
const $body = $("body");
const formReset = require("../components/formReset");

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $("button.add-to-cart-global").attr("disabled", enableOrDisable);
}

/**
* Refreshes the selected cached values for product detail content
*/
function refreshSelectedCachedValues() {
    $(".product-detail-content select").each(function () {
        const $select = $(this);
        const selectedValue = $select.find("option[selected]").val();

        if ($select.val() !== selectedValue) {
            $select.val(selectedValue).trigger("change");
        }
    });
}

module.exports = {
    methods: {
        updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements
    },

    availability: base.availability,

    addToCart: base.addToCart,

    updateAttributesAndDetails: function () {
        $("body").on("product:statusUpdate", function (e, data) {
            var $productContainer = $(".product-detail[data-pid='" + data.id + "']");

            $productContainer.find(".description-and-detail .product-attributes")
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find(".description-and-detail .description")
                    .removeClass("hidden-xl-down");
                $productContainer.find(".description-and-detail .description .content")
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find(".description-and-detail .description")
                    .addClass("hidden-xl-down");
            }

            if (data.longDescription) {
                $productContainer.find(".description-and-detail .details")
                    .removeClass("hidden-xl-down");
                $productContainer.find(".description-and-detail .details .content")
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find(".description-and-detail .details")
                    .addClass("hidden-xl-down");
            }
        });
    },

    showSpinner: function () {
        $("body").on("product:beforeAddToCart product:beforeAttributeSelect", function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $("body").on("product:afterAttributeSelect", function (e, response) {
            var dataPersonalizationModalSelector = "[data-target-personalization-modal]";
            var personalizationPriceSelector = ".personalization-price";
            var $container = response.container;
            var isNotPersonalization = !response.data.product.readyToOrder || !response.data.product.available || !response.data.product.personalization.isPersonalisable || response.data.product.availabilityInfo.isForcedOutOfStock;
            var personalizationPrice = response.data?.product?.personalization?.price;

            if ($(".product-detail>.bundle-items").length || $(".product-set-detail").eq(0).length) {
                var $dataPersonalizationModal = $container.find(dataPersonalizationModalSelector);
                $container.data("pid", response.data.product.id);
                $container.find(".product-id").text(response.data.product.id);

                if ($dataPersonalizationModal.length) {
                    if (personalizationPrice) {
                        $dataPersonalizationModal.find(personalizationPriceSelector).text(personalizationPrice);
                    }
                    $dataPersonalizationModal
                        .toggleClass("d-none", isNotPersonalization)
                        .data("action-url", $dataPersonalizationModal.data("action-url").replace(/pid=.+/, "pid=" + response.data.product.id));
                }
            } else {
                if (response.data.product) {
                    var $dataPersonalizationModalSelector = $(dataPersonalizationModalSelector);

                    $(".product-id").text(response.data.product.id);
                    $(".product-detail:not('.bundle-item')").data("pid", response.data.product.id);

                    if ($dataPersonalizationModalSelector.length) {
                        if (personalizationPrice) {
                            $dataPersonalizationModalSelector.find(personalizationPriceSelector).text(personalizationPrice);
                        }
                        $dataPersonalizationModalSelector
                            .toggleClass("d-none", isNotPersonalization)
                            .data("action-url", $dataPersonalizationModalSelector.data("action-url").replace(/pid=.+/, "pid=" + response.data.product.id));
                    }
                }
            }

            $container.find(".add-to-cart").data("product-ismandatorypersonalizable", response.data.product.personalization.isCustoMandatory);
            var $tagBadgeContainer = $container.find(".product-tagbadge");
            var $productBottleTypeContainer = $container.find(".product-type-bottle");
            var $addToCartBtn = $container.find(".add-to-cart");
            var $outOfStockBtn = $container.find(".btn-out-of-stock");
            var $availabilityMsgs = $container.find(".avalability-messages");
            var $ignoreAvailabilityMsgs = $container.find(".js-ignore-availability-messages");
            var $productName = $container.find(".product-name");
            var $originalPriceWrapper = $container.find(".original-price-wrapper");

            var currentProduct = response.data.product;
            var availabilityInfo = currentProduct.availabilityInfo;
            var productName = currentProduct.productName || "";
            var productBottleType = currentProduct.productBottleType || "";
            var isForcedOutOfStock = availabilityInfo.isForcedOutOfStock || false;
            var tagBadge = currentProduct.tagBadge || "";
            var primaryImageUrls = currentProduct.images.large || "";
            var updateImgCarousel = response.data.updateImgCarousel || false;
            var readyToOrder = currentProduct.readyToOrder || false;
            var available = currentProduct.available || false;
            var isInStock = availabilityInfo.isInStock;

            var limitedStockMessage = availabilityInfo.limitedStockMessage;
            var outOfStockMessage = availabilityInfo.outOfStockMessage;
            $availabilityMsgs.empty();
            if (limitedStockMessage) {
                $availabilityMsgs.text(limitedStockMessage);
            }

            if (outOfStockMessage && !$ignoreAvailabilityMsgs.length) {
                $availabilityMsgs.append(`<span class='d-block'>${outOfStockMessage}</span>`);
            } else {
                $ignoreAvailabilityMsgs.removeClass("js-ignore-availability-messages");
            }

            if (tagBadge) {
                $tagBadgeContainer
                    .empty()
                    .append(`<span class="tag-badge">${tagBadge}</span>`);
                setBadgeColors();
            } else {
                $tagBadgeContainer
                    .empty();
            }

            if (productBottleType) {
                $productBottleTypeContainer
                    .empty()
                    .html(productBottleType);
            } else {
                $productBottleTypeContainer
                    .empty();
            }

            // added condition so button won't be changed for MyMHCellar
            if (!availabilityInfo.isMyMHCellar) {
                if (isForcedOutOfStock || !readyToOrder || !available || !isInStock) {
                    $addToCartBtn.addClass("d-none");
                    $outOfStockBtn.removeClass("d-none");
                    $originalPriceWrapper.addClass("d-none");
                } else {
                    $addToCartBtn.removeClass("d-none");
                    $outOfStockBtn.addClass("d-none");
                    $originalPriceWrapper.removeClass("d-none");
                }
            }

            if (productName) {
                $productName
                    .html(productName);
            }

            if (primaryImageUrls && updateImgCarousel) {
                var $carousel = response.container.find(".pdp-carousel");
                var carouselOptions = {
                    infinite: true,
                    mobileFirst: true,
                    slidesToShow: 1,
                    speed: 500,
                    centerMode: false,
                    fade: true,
                    cssEase: "linear",
                    autoplay: true,
                    autoplaySpeed: $carousel.data("speed") || 3000,
                    pauseOnHover: false,
                    dots: $carousel.data("dots")
                };
                slickCarousel.default.create(currentProduct.images, response.container, carouselOptions);

                if ($carousel.hasClass("slider-not-initialized")) {
                    $carousel.removeClass("slider-not-initialized");
                }
            }
        });
    },
    updateAddToCart: function () {
        $("body").on("product:updateAddToCart", function (e, response) {
            // update local add to cart (for sets)
            $("button.add-to-cart", response.$productContainer).attr("disabled",
                (!response.product.readyToOrder || !response.product.available));

            var enable = $(".product-availability").toArray().every(function (item) {
                return $(item).data("available") && $(item).data("ready-to-order");
            });
            module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
        });
    },
    sizeChart: function () {
        $(".size-chart a").on("click", function (e) {
            e.preventDefault();
            var url = $(this).attr("href");
            var $prodSizeChart = $(this).closest(".size-chart").find(".size-chart-collapsible");
            if ($prodSizeChart.is(":empty")) {
                $.ajax({
                    url: url,
                    type: "get",
                    dataType: "json",
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    }
                });
            }
            $prodSizeChart.toggleClass("active");
        });

        var $sizeChart = $(".size-chart-collapsible");
        $("body").on("click touchstart", function (e) {
            if ($(".size-chart").has(e.target).length <= 0) {
                $sizeChart.removeClass("active");
            }
        });
    },

    hideReadmoreBtn: function () {
        $("#collapsibleLongDescription").on("show.bs.collapse", function () {
            $(".read-more").hide();
        });
    },

    scrollToInterestForm: function () {
        $(".register-your-interest-scroll").on("click", function () {
            $("html, body").animate({
                "scrollTop": $(".pdp-interest-form-container").offset().top
            }, 500);
        });
    },

    submitInterestForm: function () {
        formReset();

        $(".submit-register-interest, .submit-notify-me").on("click", function (e) {
            e.preventDefault();

            $.spinner().start();
            const $button = $(this);
            const $form = $button.closest("form");
            $button.attr("disabled", true);
            const $serverErrorField = $(".notify-me-server-error, .register-interest-server-error");
            $serverErrorField.empty();

            recaptcha.setToken({ formSelector: $form })
                .then(() => setCSRFToken({ $form: $form }))
                .then(() => {
                    $.ajax({
                        url: $button.data("href"),
                        type: "post",
                        dataType: "json",
                        data: $form.serialize(),
                        success: function (data) {
                            const $formGroup = $form.find(".form-group");
                            $.spinner().stop();

                            if (!data.success) {
                                const $acceptPrivacy = $("#register-interest-accept-privacy-cookies");

                                formHelpers.loadFormErrors($form, data);
                                $acceptPrivacy.toggleClass("is-invalid", !$acceptPrivacy.is(":checked"));
                                $formGroup.removeClass("is-valid");
                                $button.removeAttr("disabled");
                            } else {
                                formHelpers.clearPreviousErrors($form);
                                $formGroup.addClass("is-valid");
                                $button.addClass("btn-success").text(data.message);
                                $("body").trigger("cbtOutOfStockNotification", data.cbtResponse);
                            }
                        },
                        error: function (err) {
                            $.spinner().stop();
                            $button.removeAttr("disabled");
                            const response = err.responseJSON;
                            if (response.csrfError) {
                                window.location.href = response.redirectUrl;
                            }
                            const message = response.message;
                            if (message) {
                                $serverErrorField.append("<p>" + message + "</p>");
                            }
                        }
                    });
                });
        });
    },

    quantityDropdownDisplay: function () {
        $body.trigger("enhancedQuantitySelector:init", "pdp");
    },

    productTabsNavClass: function () {
        $("a[data-toggle='tab']").on("click", function() {
            var $this = $(this);
            $this.closest(".nav").find(".active").removeClass("active");
            $this.closest("li").addClass("active");
            $this.parents("ul").find("[aria-current]").attr("aria-current", false);
            $this.attr("aria-current", true);
        });
    },

    productDetailSticky: function () {
        var self = this;
        var $window = $(window);
        var $productDetailSticky = $(".product-detail-sticky");
        if ($productDetailSticky.length === 0) {
            return;
        }
        var $addToCart = $(".prices-add-to-cart-actions .btn");
        var $addToCartBtnIsBundle = $addToCart.attr("data-product-is-bundle");
        var $footer = $("footer");
        var $notifyMe = $("#notify-me-form");
        var notifyMe = $notifyMe.length ? $notifyMe.isInViewport() : false;
        var position = $window.scrollTop();
        var addToCartButtonHidden = false;
        //check if one of $addToCart elements does not contain the class d-none.
        $addToCart.each(function () {
            if ($(this).hasClass("d-none")) {
                addToCartButtonHidden = false;
                return true;
            } else {
                addToCartButtonHidden = true;
                return false;
            }
        });

        if (addToCartButtonHidden) {
            $window.on("scroll", function () {
                var scroll = $window.scrollTop();
                var isSticky = scroll > position;

                updateBottomBackToTop($productDetailSticky, isSticky);

                if ($addToCart.isInViewport() || $footer.isInViewport() || notifyMe) {
                    $productDetailSticky.removeClass("m-stick");
                } else {
                    if (isSticky) {
                        var $stickyCTABtn = $(".js-add-to-cart-copy");
                        var $mainCTABtn = $(".js-add-to-cart-main");
                        if ($addToCartBtnIsBundle) {
                            $stickyCTABtn.html($mainCTABtn.html());
                            $productDetailSticky.addClass("m-stick");
                        } else {
                            if (!$productDetailSticky.hasClass("add-to-cart-copy-attached")) {
                                $stickyCTABtn.html($mainCTABtn.html());
                                self.scrollToInterestForm();
                            }
                            $productDetailSticky.addClass("m-stick add-to-cart-copy-attached");
                        }
                    } else {
                        $productDetailSticky.removeClass("m-stick");
                    }
                }
                position = scroll;
            });
        }

    },

    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
    refreshSelectedCachedValues: refreshSelectedCachedValues
};
